import React from 'react'
import type { KambiSportName } from '@mobi/api-types/kambi/sports'
import { SportsIcon } from '@mobi/sports-offering/Components/Common/SportsIcon'

import brisbaneBroncos from './assets/NRL/brisbane-broncos.svg'
import canberraRaiders from './assets/NRL/canberra-raiders.svg'
import canterburyBankstownBulldogs from './assets/NRL/canterbury-bankstown-bulldogs.svg'
import cronullaSharks from './assets/NRL/cronulla-sharks.svg'
import goldCoastTitans from './assets/NRL/gold-coast-titans.svg'
import manlyWarringahSeaEagles from './assets/NRL/manly-warringah-sea-eagles.svg'
import melbourneStorm from './assets/NRL/melbourne-storm.svg'
import newcastleKnights from './assets/NRL/newcastle-knights.svg'
import warriors from './assets/NRL/warriors.svg'
import northQueenslandCowboys from './assets/NRL/north-queensland-cowboys.svg'
import parramattaEels from './assets/NRL/parramatta-eels.svg'
import penrithPanthers from './assets/NRL/penrith-panthers.svg'
import rabbitohs from './assets/NRL/rabbitohs.svg'
import illawarraDragons from './assets/NRL/illawarra-dragons.svg'
import sydneyRoosters from './assets/NRL/sydney-roosters.svg'
import dolphins from './assets/NRL/dolphins.svg'
import westTigers from './assets/NRL/west-tigers.svg'
import stateOfOriginNSW from './assets/NRL/NSW.svg'
import stateOfOriginQLD from './assets/NRL/QLD.svg'

import adelaideCrows from './assets/AFL/adelaide-crows-ade.svg'
import brisbaneLions from './assets/AFL/brisbane-lions-bri.svg'
import carltonBlues from './assets/AFL/carlton-blues-car.svg'
import collingwoodMagpies from './assets/AFL/collingwood-magpies-col.svg'
import essendonBombers from './assets/AFL/essendon-bombers-ess.svg'
import fremantleDockers from './assets/AFL/fremantle-dockers-fre.svg'
import goldcoastSuns from './assets/AFL/goldcoast-suns-gcs.svg'
import gwsGiants from './assets/AFL/gws-giants-gws.svg'
import hawthornHawks from './assets/AFL/hawthorn-hawks-haw.svg'
import melbourneDemons from './assets/AFL/melbourne-demons-mel.svg'
import northMelbourneKangaroos from './assets/AFL/north-melbourne-kangaroos-nor.svg'
import portAdelaidePower from './assets/AFL/port-adelaide-power-por.svg'
import richmondTigers from './assets/AFL/richmond-tigers-ric.svg'
import stkildaSaints from './assets/AFL/stkilda-saints-stk.svg'
import sydneySwans from './assets/AFL/sydney-swans-syd.svg'
import westCoastEagles from './assets/AFL/west-coast-eagles-wce.svg'
import westernBulldogs from './assets/AFL/western-bulldogs-bul.svg'
import geelongCat from './assets/AFL/geelong-cats-gee.svg'
import { IconWrapperStyled } from '../Common/Common.styles'

export const TeamIcon: React.FC<{
  size: string
  participantId: number | null
  sportName?: KambiSportName
}> = ({ size, participantId, sportName }) => {
  const iconName = participantId ? teamIconMap[participantId] : null

  if (!iconName) return <SportsIcon size={size} sport={sportName} />

  return (
    <IconWrapperStyled style={{ height: size, width: size }}>
      <img width='24' height='24' src={iconName} />
    </IconWrapperStyled>
  )
}

// =============
// Local Helpers
// =============

const teamIconMap: Record<number, string> = {
  // NRL
  1000000044: brisbaneBroncos,
  1000000085: canberraRaiders,

  1000791973: stateOfOriginNSW,
  1000791972: stateOfOriginQLD,

  1004953564: brisbaneBroncos,
  1000545006: canberraRaiders,
  1030003903: canberraRaiders,
  1030202034: canterburyBankstownBulldogs,
  1000545005: canterburyBankstownBulldogs,
  1030003905: cronullaSharks,
  1000545008: goldCoastTitans,
  1028240900: goldCoastTitans,
  1000545009: manlyWarringahSeaEagles,
  1000280267: melbourneStorm,
  1000545014: newcastleKnights,
  1000545010: warriors,
  1004953565: newcastleKnights,
  1028240902: newcastleKnights,
  1030003906: northQueenslandCowboys,
  1000545015: northQueenslandCowboys,
  1000545016: parramattaEels,
  1028240901: parramattaEels,
  1000545017: penrithPanthers,
  1000545019: rabbitohs,
  1004953567: rabbitohs,
  1000545018: illawarraDragons,
  1004953566: illawarraDragons,
  1000545020: sydneyRoosters,
  1028320297: dolphins,
  1000545021: westTigers,
  1030003904: westTigers,

  // AFL
  1000780164: adelaideCrows,
  1000780165: adelaideCrows,
  1003770531: adelaideCrows,
  1000780158: brisbaneLions,
  1003770533: brisbaneLions,
  1000780149: carltonBlues,
  1003545914: carltonBlues,
  1000780167: collingwoodMagpies,
  1003545913: collingwoodMagpies,
  1000780151: essendonBombers,
  1028303749: essendonBombers,
  1002858875: fremantleDockers,
  1003545911: fremantleDockers,
  1000780150: geelongCat,
  1005215339: geelongCat,
  1000966935: goldcoastSuns,
  1005953609: goldcoastSuns,
  1001211246: gwsGiants,
  1003545915: gwsGiants,
  1000780157: hawthornHawks,
  1028303752: hawthornHawks,
  1000780156: melbourneDemons,
  1003545909: melbourneDemons,
  1000780163: northMelbourneKangaroos,
  1005215340: northMelbourneKangaroos,
  1000780162: portAdelaidePower,
  1028303754: portAdelaidePower,
  1000780148: richmondTigers,
  1005953611: richmondTigers,
  1000780161: stkildaSaints,
  1005953610: stkildaSaints,
  1000780160: sydneySwans,
  1028303755: sydneySwans,
  1000780159: westCoastEagles,
  1005953608: westCoastEagles,
  1000780166: westernBulldogs,
  1003545910: westernBulldogs,
}

// cspell:words collingwood essendon goldcoast stkilda
// cspell:words Bankstown Warringah cronulla illawarra penrith rabbitohs
